import store from '../state/store'
import axios from 'axios'

store.on('calendar_events:index', function() {
  store.get().ui.calendar_events.set({loading: true, failed: false})

  axios.get("/api/sales/calendar_events")
  .then(function(response) {
    store.get().set({calendar_events: response.data.calendar_events})
  })
  .catch(function(error) {
    store.get().ui.calendar_events.set({failed: true})
    handleError(error)
  })
  .then(function() {
    store.get().ui.calendar_events.set({loading: false})
  })
})
